import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.blacklistLearners;

export const currentPageSelector = createSelector(
  (state) => baseSelector(state).currentPage,
  (currentPage) => currentPage
);

export const blacklistedAddMenteeStageSelector = createSelector(
  (state) => baseSelector(state).personalisedMenteeEmailersAddModalStage,
  (personalisedMenteeEmailersAddModalStage) =>
    personalisedMenteeEmailersAddModalStage
);

export const blacklistedManageMenteeStageSelector = createSelector(
  (state) => baseSelector(state).personalisedMenteeEmailersManageModalStage,
  (personalisedMenteeEmailersManageModalStage) =>
    personalisedMenteeEmailersManageModalStage
);

export const blacklistedMenteeDetailSelector = createSelector(
  (state) => baseSelector(state).manageSnoozeLearner,
  (manageSnoozeLearner) => manageSnoozeLearner
);

export const blacklistedMenteeInputErrorSelector = createSelector(
  (state) => baseSelector(state).inputErrors,
  (inputErrors) => inputErrors
);
